import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { Layout } from '@components';
import { email, whatsapp } from '@config';
import me from '../images/me.jpeg';

const VCARD_URL = '/dayron-hernandez.vcf';

const links = [
  { label: 'WhatsApp', url: `https://wa.me/${whatsapp.number}` },
  { label: 'LinkedIn', url: 'https://www.linkedin.com/in/dayron-hernandez/' },
  { label: 'Instagram', url: 'https://www.instagram.com/dayronzk' },
  { label: 'Web', url: 'https://dayronhernandez.es' },
  { label: 'Email', url: `mailto:${email}` },
];

const StyledContact = styled.main`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  /* El padding-top debe superar la altura del nav fijo para no quedar cortado. */
  padding: calc(var(--nav-height) + 50px) 25px 70px;

  @media (max-width: 480px) {
    padding: calc(var(--nav-height) + 30px) 18px 60px;
  }

  .card {
    width: 100%;
    max-width: 440px;
    text-align: center;
    background-color: var(--light-navy);
    border: 1px solid var(--lightest-navy);
    border-radius: var(--border-radius);
    padding: 48px 32px 36px;
    ${({ theme }) => theme.mixins.boxShadow};

    @media (max-width: 480px) {
      padding: 40px 22px 30px;
    }
  }

  .avatar {
    width: 128px;
    height: 128px;
    margin: 0 auto 22px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid var(--green);
  }

  .name {
    margin: 0;
    color: var(--lightest-slate);
    font-size: var(--fz-heading);
  }
  .role {
    margin: 6px 0 0;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: var(--fz-sm);
  }
  .phrase {
    margin: 16px auto 0;
    max-width: 340px;
    color: var(--slate);
    font-size: var(--fz-md);
    font-style: italic;
  }

  .save {
    ${({ theme }) => theme.mixins.bigButton};
    display: inline-block;
    width: 100%;
    margin: 30px 0 22px;
    font-size: var(--fz-md);
  }

  .socials {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
    gap: 10px;
  }
  .socials a {
    ${({ theme }) => theme.mixins.smallButton};
    text-align: center;
    font-size: var(--fz-xs);
  }
`;

const ContactPage = ({ location }) => {
  const handleSave = () => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'guardar_contacto', { method: 'vcard' });
    }
  };

  return (
    <Layout location={location}>
      <Helmet>
        <title>Guardar contacto | Dayron Hernández</title>
      </Helmet>

      <StyledContact>
        <div className="card">
          <img className="avatar" src={me} alt="Dayron Hernández" />
          <h1 className="name">Dayron Hernández</h1>
          <p className="role">Estratega Tecnológico &amp; Arquitecto de Soluciones</p>
          <p className="phrase">Transformo información en decisiones, sistemas y resultados.</p>

          <a className="save" href={VCARD_URL} download onClick={handleSave}>
            Guardar contacto
          </a>

          <div className="socials">
            {links.map(({ label, url }) => (
              <a key={label} href={url} target="_blank" rel="noopener noreferrer">
                {label}
              </a>
            ))}
          </div>
        </div>
      </StyledContact>
    </Layout>
  );
};

ContactPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default ContactPage;
